// extracted by mini-css-extract-plugin
export default {"container":"Article_container__syND5","content":"Article_content__p4vqJ","actions":"Article_actions__G+ZBx","favorite":"Article_favorite__Wsmkj"};